import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import * as React from 'react'

interface Props {
  rows: number
  columns: number
}

export const EmptyRows: React.FC<Props> = ({ rows, columns }) =>
  rows > 0 ? (
    <TableRow style={{ height: 52 * rows }}>
      <TableCell colSpan={columns} />
    </TableRow>
  ) : null
EmptyRows.displayName = 'EmptyRows'
